/**
 * The small pieces of English the shared components assemble.
 *
 * A button label built as `Add a ${noun}` reads "Add a answer" the moment somebody names a section
 * after something that starts with a vowel, and a validation message built as
 * `Add at least one ${noun}` reads "Add at least one a tier" the moment somebody puts the article
 * into the noun to work around the first problem. Both were on screen. The article belongs to the
 * sentence, not to the noun, so the nouns are bare everywhere and this file adds it.
 */

/**
 * Words that begin with a vowel LETTER and a consonant SOUND, which is the only case the plain
 * rule gets wrong here. Kept to the shapes rather than the words — anything starting `uni-`, `use`,
 * `eu-` or `one` takes "a" — so a noun nobody has thought of yet is still right.
 */
const CONSONANT_SOUNDED = /^(uni|use|user|usu|eu|one|ubi)/i;

/** Words that begin with a consonant LETTER and a vowel SOUND. */
const VOWEL_SOUNDED = /^(hour|honest|heir|honou?r)/i;

/** `answer` → `an answer`, `tier` → `a tier`, `hour` → `an hour`. */
export function withArticle(noun: string): string {
  const trimmed = noun.trim();
  if (trimmed.length === 0) return trimmed;
  const vowelLetter = /^[aeiou]/i.test(trimmed);
  const takesAn = VOWEL_SOUNDED.test(trimmed) || (vowelLetter && !CONSONANT_SOUNDED.test(trimmed));
  return `${takesAn ? 'an' : 'a'} ${trimmed}`;
}
